import { getAuMenus, getComMenus, getDeMenus, getEsMenus, getFrMenus, getGbrMenus, getIrlMenus, getNlMenus, getPlMenus, getFiMenus, } from './countryMenus';
export const getNavItems = ({ navProps, locale = '', }) => {
    var _a;
    const { customer } = navProps;
    if (!customer) {
        return getComMenus({ navProps, locale });
    }
    const navItemsByCountries = {
        'de-DE': getDeMenus(navProps),
        'de-AT': getAuMenus(navProps),
        'en-GB': getGbrMenus(navProps),
        'fr-FR': getFrMenus(navProps),
        'es-ES': getEsMenus(navProps),
        'nl-NL': getNlMenus(navProps),
        'en-IE': getIrlMenus(navProps),
        'pl-PL': getPlMenus({ navProps, locale }),
        'fi-FI': getFiMenus({ navProps, locale }),
    };
    return (_a = navItemsByCountries[locale]) !== null && _a !== void 0 ? _a : getComMenus({ navProps, locale });
};
//# sourceMappingURL=menus.js.map